import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const groupPharmacyListsRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/pharmacy_lists',
  validateSearch: z.object({
    tab: z.enum(['active', 'archived']).default('active'),
    query: z.string().optional(),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/group/PharmacyLists/PharmacyListsPage/PharmacyListsPage').then((d) => d.Route)
);
